// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"a33cdc78","453":"ad7768ec","518":"25cfff3e","649":"bc818e8e","859":"19a8e752"}[chunkId] + ".chunk.js";
};